import React from 'react';

import IconButton from '@mui/material/IconButton';

import { ReactComponent as InitioLogo } from '../images/initio-logo.svg';
import redwoodseedLogo from '../images/redwoodseed-logo.png';

import useTheme from '../hooks/useTheme';

import './NavBar.scss';

export default function NavBar() {
  const theme = useTheme();
  const renderLogo = () => {
    if (!theme) {
      return <InitioLogo />;
    }

    if (theme.logoType === 'png') {
      return <img src={redwoodseedLogo} alt={`${theme.name} Logo`} />;
    }

    return <InitioLogo />;
  };

  return (
    <div className="NavBar">
      <IconButton
        className="initio-logo"
        onClick={() => {
          let redirectUrl;
          
          if (process.env.NODE_ENV === 'development') {
            // Development: use env variable with tenant query parameter
            redirectUrl = process.env.REACT_APP_AUTH_HOSTNAME;
            if (theme?.name) {
              const urlParams = new URLSearchParams();
              urlParams.set('tenant', theme.name.toLowerCase());
              redirectUrl = `${redirectUrl}?${urlParams.toString()}`;
            }
          } else {
            // Production: use current domain (keeps tenant subdomain)
            redirectUrl = window.location.origin;
          }
          
          window.location.assign(redirectUrl);
        }}
      >
        {renderLogo()}
      </IconButton>
    </div>
  );
}
